module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-icon",
    attrs: {
      "id": "toggle-menu"
    },
    on: {
      "click": _vm.toggleMenuState
    }
  }, [_c('div', {
    class: _vm.navIconClasses,
    attrs: {
      "id": "nav-icon"
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4aba8c7e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationIcon.vue
// module id = 914
// module chunks = 1